import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCitroenComponent } from './simple-icons-citroen.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCitroenComponent ],
    exports:      [ SimpleIconsCitroenComponent ],
    bootstrap:    []
})
export class SimpleIconsCitroenModule {}
